<template>
  <div v-if="true">
    <div class="form-group row">
      <div class="col-md-12 pt-1">
        <h5 class="text-third"><i class="fa fa-lock"></i> Permissão visualização</h5>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-5">
        <b-form-input type="text" placeholder="Filtrar Usuários"
          v-model="filterLeft" />
        <div class="text-center" style="overflow-y: auto; max-height:40vh">
          <table class="table table-hover" style="border: 1px solid #dcdede;" >
            <thead class="thead-third" style="border: solid 1px #0277bd; height: 44px;">
              <tr>
                <th class="text-center col-1"><input type="checkbox" v-model="selectAllLeftTable"></th>
                <th class="text-center">Nome</th>
              </tr>
            </thead>
            <tr v-for="usuario in filteredRowsLeft" :key="usuario.id">
              <td v-if="allSelectedLeftTable" class="text-center col-1"><input v-model="allSelectedLeftTable" type="checkbox" checked disabled/></td>
              <td v-else class="text-center col-1"><input v-model="selectedUserListLeftTable" :value="usuario.id" type="checkbox"/></td>
              <td class="text-center">{{usuario.username}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="d-flex flex-column col-md-2 align-self-center align-items-center">
        <div class="pb-3">
          <button type="button" class="btn btn-third btn-sm" v-on:click="moveToRight()" v-b-tooltip.hover><i class="fas fa-arrow-right"></i> <span class="d-md-down-none"></span></button>
        </div>
        <div>
          <button type="button" class="btn btn-danger btn-sm" v-on:click="moveToLeft()" v-b-tooltip.hover><i class="fas fa-arrow-left"></i> <span class="d-md-down-none"></span></button>
        </div>
      </div>
      <div class="col-md-5">
          <b-form-input type="text" placeholder="Filtrar Permitidos"
            v-model="filterRight" />
          <div class="text-center" style="overflow-y: auto; max-height:40vh">
            <table class="table table-hover" style="border: 1px solid #dcdede;" >
              <thead class="thead-third" style="border: solid 1px #0277bd; height: 44px;">
                <tr>
                  <th class="text-center col-1"><input type="checkbox" v-model="selectAllRightTable"></th>
                  <th class="text-center">Nome</th>
                </tr>
              </thead>
              <tr v-for="usuario in filteredRowsRight" :key="usuario.id">
                <td v-if="allSelectedRightTable" class="text-center col-1"><input v-model="allSelectedRightTable" type="checkbox" checked disabled/></td>
                <td v-else class="text-center col-1"><input v-model="selectedUserListRightTable" :value="usuario.id" type="checkbox"/></td>
                <td class="text-center">{{usuario.username}}</td>
              </tr>
            </table>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { loading } from '@/shared/utils/UIHelper'
import AccountRepository from '@/shared/http/repositories/configurations/account.js'

export default {
  name: 'Account',
  props: {
    idFuncionarios: {
      type: Set,
      default: () => new Set()
    }
  },
  data () {
    return {
      usersList: [],
      usersAlreadyWithPermission: [],
      selectedUserListLeftTable: [],
      selectedUserListRightTable: [],
      allSelectedLeftTable: false,
      allSelectedRightTable: false,
      filterLeft: '',
      filterRight: ''
    }
  },
  computed: {
    selectAllLeftTable: {
      get: function () {
        return this.allSelectedLeftTable
      },
      set: function () {
        if (this.allSelectedLeftTable) {
          this.allSelectedLeftTable = false
        } else {
          this.allSelectedLeftTable = true
        }
      }
    },
    filteredRowsLeft () {
      return this.usersList.filter(row => {
        const u = row.username.toString().toLowerCase()
        const search = this.filterLeft.toLowerCase()
        return u.includes(search)
      })
    },
    filteredRowsRight () {
      return this.usersAlreadyWithPermission.filter(row => {
        const u = row.username.toString().toLowerCase()
        const search = this.filterRight.toLowerCase()
        return u.includes(search)
      })
    },
    selectAllRightTable: {
      get: function () {
        return this.allSelectedRightTable
      },
      set: function () {
        if (this.allSelectedRightTable) {
          this.allSelectedRightTable = false
        } else {
          this.allSelectedRightTable = true
        }
      }
    }
  },
  created () {
    this.loadAccounts()
  },
  methods: {
    moveToLeft () {
      if (this.selectAllRightTable) {
        this.usersList.push(...this.usersAlreadyWithPermission.splice(0, this.usersAlreadyWithPermission.length))
        this.selectAllRightTable = false
        return
      }
      this.selectedUserListRightTable.forEach(x => {
        let pos = this.usersAlreadyWithPermission.findIndex(k => k.id === x)
        let item = this.usersAlreadyWithPermission.splice(pos, 1)
        this.usersList.push(item[0])
      })
      this.selectedUserListRightTable = []

      this.updatePermissionList()
    },
    moveToRight () {
      if (this.selectAllLeftTable) {
        this.usersAlreadyWithPermission.push(...this.usersList.splice(0, this.usersList.length))
        this.selectAllLeftTable = false
        return
      }
      this.selectedUserListLeftTable.forEach(x => {
        let pos = this.usersList.findIndex(k => k.id === x)
        let item = this.usersList.splice(pos, 1)
        this.usersAlreadyWithPermission.push(item[0])
      })
      this.selectedUserListLeftTable = []

      this.updatePermissionList()
    },
    updatePermissionList () {
      this.$emit('UpdatePermissionList', this.usersList, this.usersAlreadyWithPermission)
    },
    loadAccounts () {
      loading.push()
      AccountRepository.GetAll()
        .then((response) => {
          response.data.content.forEach((x) => {
            if (x.funcionario) {
              if (x.funcionario && this.idFuncionarios.has(x.funcionario.id)) {
                this.usersAlreadyWithPermission.push(x)
                return
              }
              this.usersList.push(x)
            }
          })
          this.updatePermissionList()
          loading.pop()
        })
    },
    setEmployeesAlreadyWithPermission (idFuncionarios) {
      this.usersList = this.usersList.map((x) => {
        if (idFuncionarios.has(x.funcionario.id)) {
          this.usersAlreadyWithPermission.push(x)
          return
        }
        return x
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/account/components/permissionEmployees/permissionsTable.vue